import meetingState from '../data/constants/meetingState';

export default function (state) {
    switch (state) {
        case meetingState.CONFIRMED:
            return 'confirmed';
        case meetingState.CANCELLED:
            return 'cancelled';
        case meetingState.PENDING:
        default:
            return '';
    }
};
